import i18n from "@/i18n";

let height: number;
let width: number;
let textBoxes: HTMLCollection;
const draggableBox = function (editor: any) {
    editor.ui.registry.addButton("draggableBox", {
        icon: "comment",
        tooltip: i18n.t("htmlEditor.draggableBox"),
        onAction: function () {
            width = editor.getBody().clientWidth;
            height = editor.getBody().scrollHeight;
            let empty = false;
            if (editor.getContent().length === 0) empty = true;

            const textBox = document.createElement("div");
            const p = document.createElement("p");
            textBox.className = "textBox";
            p.textContent = "Lorem Ipsum";
            textBox.appendChild(p);

            // Default styles
            p.style.textAlign = "center";
            p.style.fontSize = "25px";
            textBox.style.position = "absolute";
            textBox.style.top = "0px";
            textBox.style.left = "0px";
            textBox.style.minWidth = "50px";

            editor.setContent(editor.getContent() + textBox.outerHTML);

            if (empty) editor.setContent("&#8205;" + editor.getContent());
            empty = false;
        },
        onSetup: function () {
            if (!editor.getBody().classList.contains("vs_init")) {
                editor.getBody().classList.add("vs_init");
                editor.on("SetContent", function () {
                    textBoxes = editor.getBody().getElementsByClassName("textBox");
                    for (const item of textBoxes) {
                        Draggable(item);
                    }
                });
            }
        }
    });

    function Draggable(el: any) {
        width = editor.getBody().clientWidth;
        height = editor.getBody().scrollHeight;

        el.removeEventListener("mousedown", mDown);

        var maxI: string;
        var x = 0;
        var y = 0;
        function mUp() {
            el.isDown = false;
            editor.getBody().removeEventListener("mousemove", mMove);
            editor.getBody().removeEventListener("mouseleave", mLeave);
            editor.getBody().removeEventListener("mouseup", mUp);
            el.style.zIndex = "";
            var zs = [];
            for (const item of textBoxes) {
                zs.push((item as any).style.zIndex);
            }
            maxI = (1000 + Math.max(...zs)) + "";
            el.style.zIndex = maxI;
            el.setAttribute("data-mce-style", el.style.cssText);
        }
        function mLeave() {
            if (el.isDown) mUp();
        }
        function mDown(e: any) {
            if (e.offsetX > (el.clientWidth / 2) - 7 && e.offsetX < (el.clientWidth / 2) + 7 && e.offsetY >= (el.scrollHeight - 12)) {
                el.isDown = true;
                editor.getBody().addEventListener("mousemove", mMove);
                editor.getBody().addEventListener("mouseleave", mLeave);
                editor.getBody().addEventListener("mouseup", mUp);
                el.offset = [
                    el.offsetLeft - e.clientX,
                    el.offsetTop - e.clientY
                ];
                x = (e.clientX + el.offset[0]);
                y = (e.clientY + el.offset[1]);
                el.style.zIndex = "100001";
            }
        }
        function mMove(e: any) {
            if (!el.isDown) return;
            e.preventDefault();
            if (e.clientX + el.offset[0] >= 0 && e.clientX + el.offset[0] + el.clientWidth <= width) {
                x = (e.clientX + el.offset[0]);
                el.style.left = x + "px";
            }
            if (e.clientY + el.offset[1] >= 0 && e.clientY + el.offset[1] + el.scrollHeight - 12 <= height) {
                y = (e.clientY + el.offset[1]);
                el.style.top = y + "px";
            }
        }
        var clone = el.cloneNode(true);
        el.parentNode.replaceChild(clone, el);
        el = clone;
        el.addEventListener("mousedown", mDown);
    };
};

export { draggableBox };
